<template>
  <!--  这是充值页面   -->
  <div class="recharge_wrap">
    <div class="base-header">
      <div class="back_left" @click="back()">
      </div>
      <div class="title">
        <p>{{ $t("昵称") }}</p>
      </div>
    </div>
    <form class="form">
      <div class="recharge_wrap">
<!--        <p>{{ $t("充值金额") }}</p>-->
        <div class="flex_center">
<!--          <div>{{ $t("钱符") }}</div>-->
          <input v-model.trim="data.nickname" type="text" step="10" class="inp"/>
        </div>
      </div>

    </form>

    <div class="basic_btn sbtn" @click="submit">
      {{ $t("提交") }}
    </div>

    <div class="game-box" id="bigBox" v-show="show_game_box">
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox, RadioGroup, Icon, Radio } from "vant";
import Fetch from "../../utils/fetch";
import UserInfo from "@/components/userInfo";
import baseHeader from "@/components/baseHeader";

Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CountDown).use(Checkbox).use(Icon);

export default {
  name: "nickname",
  data() {
    return {
      time: 0,
      eye: 1,
      balance: 0.0,
      data: {
        choose: "",
        channel: "",
        money: 30,
        id: "",
        reason: "there is no need to fill",
        nickname: ''
      },
      recharge_list: [],
      payment: [],
      payment_index: 1,
      config: {},
      actualAmount: "",
      bonus: 0,
      show_game_box: false,
      is_active: false,
    };
  },
  created() {
    this.$parent.footer("user", false);
  },
  components: {
    UserInfo,
    baseHeader,
  },
  mounted() {
    Fetch("/user/getUserInfoApi").then(res => {
      this.data.nickname = res.data.nickname;
    })
  },
  methods: {
    back() {
      if (this.show_game_box) {
        document
            .getElementById("bigBox")
            .removeChild(document.getElementById("myiframe"));
        this.show_game_box = false;
      } else {
        this.$router.go(-1)
      }
    },
    ki(v) {
      return Math.round(v);
    },

    submit() {
      localStorage.setItem("recharge_money", this.data.money);
      this.$toast.loading({ mask: true, duration: 0 });
      Fetch(
          "/user/updateNickname",
          {
            nickname: this.data.nickname,
          },
          null,
          false
      )
          .then((r) => {
            if (r.code == 1) {
              this.$router.go(-1)
            } else {
              this.$toast(this.$t("系统繁忙,请稍后再尝试"));
            }
          });
    },
    loadUrl(url) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.setAttribute("src", url);
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
    },
  },
};
</script>

<style lang="less" scoped>
.ades {
  width: 95%;
  margin: 15px auto;
  font-size: 0.37rem;
  color: rgba(255, 255, 255, 0.737);
  line-height: 24px;
  text-indent: 10px;
  color: goldenrod;
}

.base-header {
  height: 45px;
  // width: 100%;
  display: flex;
  // background: rgb(29, 40, 70);
  background: #0e4114;
  text-align: center;
  align-items: center;
  // justify-items: center;
  // align-content: center;
  justify-content: space-between;

}

.telegram {
  position: absolute;
  width: 1.3rem;
  bottom: 100px;
  right: 20px;
  z-index: 1;
}

.back_left {
  background: url("../images/item/back.png") no-repeat;
  background-size: 14px 20px;
  background-position: center;
  width: 15%;
}

.big_tit {
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  // display: flex;
  text-align: center;
  line-height: 44px;
  align-items: center;
  justify-items: center;
  width: 40%;
  height: 100%;
}

.is-active {
  background: #8428e9;
}

.game-box {
  position: fixed;
  top: 44px;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  z-index: 9999;
}

.flex_center {
  padding: 5px 5px;
   background-color: #3fb045;
  color: white;
  justify-content: space-around;
  font-weight: 700;
  border: white;
  border-radius: 50px;
}

.flex_center>div {
  width: auto;
  font-size: 0.5rem;
}

.inp {
  height: 30px;
  font-size: 0.5rem;
  color: white;
}

.mactive {
  //border:1px solid #e4392e!important;
  color: #fff !important;
  font-weight: 700;
  // background: rgb(242, 208, 175) !important;
  background: rgb(132, 40, 233) !important;
}

.fast-money>p {
  margin-bottom: 3px !important;
}

.fast-money {
  width: 30%;
  // height: 1rem;
  // line-height: 1rem;
  text-align: center;
  //border: 1px solid #e5e5e5;
  margin-bottom: 0.2rem;
  border-radius: 6px;
  float: left;
  background: rgb(34, 25, 62);
  color: white;
  font-size: 0.35rem;
  padding: 10px 0;
}

.ml5 {
  margin-left: 5%;
}

.top_right {
  position: absolute;
  font-size: 13px;
  line-height: 18px;
  color: #ffffff;
  top: 36px;
  right: 14px;
}

.recharge_fs {
  margin-top: 10px;
  background: #000;
  border-radius: 6px;
  padding: 0 16px;
}

.recharge_box {
  width: 100%;
  height: 48px;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  margin-top: 12px;
  padding: 16px 11px;


}

.form {
  width: 96%;
  margin-left: 2%;
  margin-top: 8px;

  .recharge_wrap {
    width: 100%;
    // background: rgb(43, 56, 100);
     background: #0e4114;
    padding: 10px 20px;

    .reason {
      width: 100%;
    }



    div {
      span:nth-child(1) {
        font-size: 0.5rem;
        margin-right: 10px;
        font-weight: bold;
        color: white;
      }

      span:nth-child(3) {
        font-size: 0.5rem;
        width: 40%;
        color: #999;
        text-align: right;
      }
    }

    p:nth-child(1) {
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      margin-bottom: 20px;
    }

    p:nth-child(3) {
      color: #999;
      margin-top: 20px;
    }
  }

  .tit {
    // height: 40px;
    border-bottom: 1px solid #ececec;
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    line-height: 54px;
    padding-bottom: 1px;
    margin-bottom: 3px;
  }

  .item {
    height: 45px;
    width: 100%;
    //border-bottom: 1px solid #ECECEC;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &:last-child {
      border-bottom: none;
    }

    .check {
      width: 16px;
      height: 16px;
      margin-left: 4px;
      background: url(../images/user/c2.png) no-repeat center center;
      background-size: 100% 100%;

      &.checked {
        background: url(../images/user/c1.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .re_icon {
      width: 20px;
      height: 20px;
      margin-left: 11px;

      img {
        width: 28px;
        height: 20px;
      }
    }

    .re_name {
      font-size: 16px;
      line-height: 22px;
      color: #d2e0fd;
      margin-left: 20px;
    }
  }
}

.tip {
  width: 100%;
  margin-top: 8px;
  border-radius: 5px;
  padding: 8px;
  color: #e5e5e5;
  line-height: 24px;
  font-size: 0.3rem;
  background: #000;
}
.title {
  text-align: center;
  color: white;
  margin-left: 10px;
  margin-right: 180px;
  font-size: 0.5rem;
}

.sbtn {
  position: fixed;
  bottom: 30px;
  left: 5%;
  margin: 53px auto 0 auto;
  width: 90%;
  color: #efeeee;
  border-radius: 22px;
  background: #0d7319;
  font-size: 0.5rem;
  font-weight: 700;
}
</style>
